export default "__VITE_ASSET__kFvvNz9K__"